// extracted by mini-css-extract-plugin
export default {"error":"ErrorMessage_error__MR0Ic","errorText":"ErrorMessage_errorText__BxPuU","errorClose":"ErrorMessage_errorClose__BrWAc"};